export default __webpack_public_path__ + "static/media/MarkerIconOrange.c9b833ac.svg";